<template>
    <div>
        <el-row>
            <el-col :span="6">
                <el-row>
                    <booking-calendar-pick-date-dialog :dialog="dialog"/>
                    <booking-calendar-holiday-dialog :holidayDetail.sync="holidayDetail"/>
                    <el-col :span="24" class="text-left" style="padding-top: 20px;">
                        <el-dropdown hide-on-click>
                            <el-button type="primary" class="text-left booking-calendar-base-drop-down-kan-style">
                                <span class="font-sarabun-kan-style font-size-16-kan-style">จัดการ<i class="el-icon-arrow-down el-icon--right " style="padding-left: 30px;"></i></span>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="item in BookManage" :key="item.id" class="booking-calendar-base-drop-down-btn-kan-style" @click.native="showDialog(item.id)">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>
                </el-row>
                <el-row v-if="hide">
                    <el-col :span="24" class="text-left" style="margin: 12px 0;">
                        <span class="font-sarabun-kan-style font-size-16-kan-style booking-calendar-check-list-header-kan-style">ขนส่ง</span>
                    </el-col>
                    <el-col :span="24" class="text-left">
                        <el-checkbox-group v-model="calendarObj.courierName" @change="handleSelectCourierName">
                            <el-checkbox
                                v-for="item in courierNameArray"
                                :key="item.id"
                                :label="item.courierId"
                                class="booking-calendar-courier-checkbox-kan-style"
                                type="error"
                                :style=" `--tooltip-color: ${item.color};`"
                            ><span style="color: #2C3E50;">{{item.label}}</span></el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row v-if="hide">
                    <el-col :span="24" class="text-left" style="margin: 12px 0;">
                        <span class="font-sarabun-kan-style font-size-16-kan-style booking-calendar-check-list-header-kan-style">ประเภทลูกค้า</span>
                    </el-col>
                    <el-col :span="24" class="text-left">
                        <el-checkbox-group v-model="calendarObj.calendarTypes" @change="handleSelectCalendarTypes">
                        <el-row v-for="item in courierTypeArray" :key="item.id">
                            <el-col :span="24" class="text-left">
                                <el-checkbox
                                    :label="item.calendarType"
                                    type="error"
                                    class="booking-calendar-type-checkbox-kan-style">
                                    <span style="color: #2C3E50;">{{item.label}}</span>
                                </el-checkbox>
                            </el-col>
                            <el-checkbox-group v-model="calendarObj.bookingType" @change="handleSelectBookingType">
                                <el-row v-for="item in item.courierTypeDetailArray" :key="item.id">
                                    <el-col :span="24" class="text-left" style="padding-left: 30px;">
                                        <el-checkbox
                                            :disabled="isDisableSubTypeCalendar"
                                            :label="item.calendarType"
                                            type="error"
                                            class="booking-calendar-type-checkbox-kan-style">
                                            <span style="color: #2C3E50;">{{item.label}}</span>
                                        </el-checkbox>
                                    </el-col>
                                </el-row>
                            </el-checkbox-group>
                        </el-row>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row v-if="hide">
                    <el-col :span="24" class="text-left" style="margin: 12px 0;">
                        <span class=" font-sarabun-kan-style font-size-16-kan-style booking-calendar-check-list-header-kan-style">วันหยุด</span>
                    </el-col>
                    <el-col :span="24" class="text-left">
                        <el-checkbox-group v-model="calendarObj.courierHolidays" @change="handleSelectCourierHolidays">
                            <el-checkbox
                                v-for="item in courierNameArray"
                                :key="item.id"
                                class="booking-calendar-holiday-checkbox-kan-style"
                                :label="item.courierId"
                                type="error"><span style="color: #2C3E50;">{{item.label}}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
            </el-col>
            <el-col v-if="hide" :span="18" v-loading="bookingCalendarObj.loading">
                <booking-calendar-courier-detail-dialog :dateDetail.sync="dateDetail"/>
                <full-calendar
                    class="book-calendar-kan-style"
                    ref="bookingCalendar"
                    defaultView="dayGridMonth"
                    :header="false"
                    :eventLimit="5"
                    eventOrder="type"
                    timeZone='local'
                    :height="750"
                    :plugins="calendarPlugins"
                    :events="events"
                    :eventLimitClick="false"
                    :eventRender="datesRender"
                    @eventClick="handleEventClick"
                    @dateClick="handleDateClick"
                />
            </el-col>
        </el-row>
    </div>
</template>

<script>
// import fgApi from '@/services/fillgoods'
import BookingCalendarPickDateDialog from '@/components/Booking/BookingCalendar/BookingCalendarPickDateDialog.vue'
import BookingCalendarCourierDetailDialog from '@/components/Booking/BookingCalendar/BookingCalendarCourierDetailDialog.vue'
import BookingCalendarHolidayDialog from '@/components/Booking/BookingCalendar/BookingCalendarHolidayDialog.vue'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

// must manually include stylesheets for each plugin
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'

// pathify
import { sync, call } from 'vuex-pathify'

// dayjs
import 'dayjs/locale/th'

export default {
    name: 'BookingCalendarBase',
    components: {
        'full-calendar': FullCalendar,
        'booking-calendar-pick-date-dialog': BookingCalendarPickDateDialog,
        'booking-calendar-courier-detail-dialog': BookingCalendarCourierDetailDialog,
        'booking-calendar-holiday-dialog': BookingCalendarHolidayDialog
    },
    data () {
        return {
            hide: true,
            calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin
            ],
            events: [],
            calendarObj: {
                date: {
                    month: '',
                    year: ''
                },
                courierName: [],
                calendarTypes: [],
                bookingType: [],
                courierHolidays: [],
                calendarInfo: {}
            },
            isDisableSubTypeCalendar: false,
            BookManage: [
                { id: 0, name: 'วันหยุด' },
                { id: 1, name: 'เรียกรถขนส่ง' }
            ],
            dialog: {
                show: false
            },
            dateDetail: {
                show: false,
                date: '',
                info: []
            },
            holidayDetail: {
                holidayId: '',
                info: [],
                holidayName: '',
                holidayDate: '',
                show: false,
                holidayArray: []
            },
            courierNameArray: [
                { id: 0, courierId: 1, label: 'SCG Express', color: '#08A7A3' },
                { id: 1, courierId: 4, label: 'Flash Express', color: '#F9EC00' },
                { id: 2, courierId: 10, label: 'Bee Express', color: '#FFAA00' },
                { id: 3, courierId: 9, label: 'Best Express', color: '#FC5C5C' }
            ],
            courierTypeArray: [
                { id: 0, calendarType: 1, label: 'ส่งประจำครั้งแรก' },
                { id: 1, calendarType: 2, label: 'ส่งครั้งเดียว' },
                {
                    id: 2,
                    calendarType: 3,
                    label: 'ส่งประจำ',
                    courierTypeDetailArray: [
                        { id: 0, calendarType: 1, label: 'จันทร์ - เสาร์' },
                        { id: 1, calendarType: 2, label: 'จันทร์ - ศุกร์' },
                        { id: 2, calendarType: 3, label: 'กำหนดเอง' }
                    ]
                },
                { id: 3, calendarType: 4, label: 'ส่งประจำหยุด' }
            ]
        }
    },
    computed: {
        ...sync('booking/*')
    },
    watch: {
        bookingCalendarObj: {
            deep: true,
            async handler (info) {
                this.calendarObj = { ...info }
                this.events = []
                this.holidayDetail.holidayArray = []
                for (let key in info.calendarInfo) {
                    let element = info.calendarInfo[key]
                    if (element.holiday) {
                        let info = {
                            type: 0,
                            holiday: true,
                            courierHolidayId: element.holiday.courierHolidayId,
                            courierIds: element.holiday.courierIds,
                            title: element.holiday.name,
                            start: element.holiday.date,
                            backgroundColor: '#FF0000',
                            borderColor: '#FF0000'
                        }
                        this.holidayDetail.holidayArray.push(element.holiday.date)
                        this.events.push(info)
                    } else {
                        let infoNoHoliday = {
                            type: 0,
                            title: '',
                            start: `${info.date.year}-${info.date.month}-${this.dateFilter(key)}`,
                            backgroundColor: 'rgba(255, 255, 255, .0)',
                            borderColor: 'rgba(255, 255, 255, .0)'
                        }
                        this.events.push(infoNoHoliday)
                    }
                    element.bookings.forEach(e => {
                        let param = {
                            id: e.courierId,
                            type: e.calendarType,
                            pickUpAddressId: e.pickupAddressIds,
                            weekday: this.$dayjs(`${info.date.year}-${info.date.month}-${this.dateFilter(key)}`).get('d'),
                            bookingType: e.calendarType === 3 ? this.bookingCalendarObj.bookingType : [],
                            title: `${e.courierName} ${this.calendarTypeFilter(e.calendarType)} - ${e.count}`,
                            start: `${info.date.year}-${info.date.month}-${this.dateFilter(key)}`,
                            backgroundColor: this.calendarEventsColor(e.courierId),
                            borderColor: this.calendarEventsColor(e.courierId)
                        }
                        this.events.push(param)
                    })
                }
            }
        }
    },
    async created () {
        this.bookingCalendarObj.loading = true
        await this.fetchCalendarEventInfo()
        this.$store.set('booking/bookingCalendarRef', this.$refs.bookingCalendar)
        this.bookingCalendarObj.loading = false
    },
    methods: {
        ...call('booking/*'),
        calendarTypeFilter (id) {
            switch (id) {
            case 1:
                return 'ส่งประจำครั้งแรก'
            case 2:
                return 'ส่งครั้งเดียว'
            case 3:
                return 'ส่งประจำ'
            case 4:
                return 'ส่งประจำหยุด'
            default:
                return ''
            }
        },
        dateFilter (key) {
            return (key < 10) ? `0${key}` : key
        },
        showDialog (item) {
            if (item === 0) {
                this.holidayDetail.show = true
                this.holidayDetail.isEdit = false
                this.holidayDetail.info = []
                this.holidayDetail.holidayId = ''
                this.holidayDetail.holidayName = ''
                this.holidayDetail.holidayDate = ''
            } else {
                this.dialog.show = true
            }
        },
        calendarEventsColor (id) {
            switch (id) {
            case 1:
                return '#08A7A3'
            case 4:
                return '#F9EC00'
            case 9:
                return '#FC5C5C'
            case 10:
                return '#FFAA00'
            default:
                return '#A0A0A0'
            }
        },
        handleDateClick (arg) {
            this.dateDetail.info = []
            this.dateDetail.show = true
            this.dateDetail.date = this.$dayjs(new Date(arg.dateStr)).locale('th').format('DD MMMM YYYY')
            let data = this.events.filter(e => {
                return e.start === arg.dateStr
            })
            this.dateDetail.info = data
        },
        handleEventClick (arg) {
            if (arg.event.extendedProps.holiday) {
                this.holidayDetail.show = true
                this.holidayDetail.isEdit = true
                this.holidayDetail.info = arg.event.extendedProps.courierIds
                this.holidayDetail.holidayId = arg.event.extendedProps.courierHolidayId
                this.holidayDetail.holidayName = arg.event.title
                this.holidayDetail.holidayDate = arg.event.start
            } else {
                this.dateDetail.info = []
                this.dateDetail.show = true
                this.holidayDetail.isEdit = false
                this.dateDetail.date = this.$dayjs(new Date(arg.event.start)).locale('th').format('DD MMMM YYYY')
                let selectdate = this.$dayjs(new Date(arg.event.start)).format('YYYY-MM-DD')
                let data = this.events.filter(e => {
                    return e.start === selectdate
                })
                this.dateDetail.info = data
            }
        },
        async handleSelectCourierName (val) {
            this.bookingCalendarObj.loading = true
            this.bookingCalendarObj.courierName = val
            await this.fetchCalendarEventInfo()
            this.bookingCalendarObj.loading = false
        },
        async handleSelectCalendarTypes (val) {
            this.bookingCalendarObj.loading = true
            this.bookingCalendarObj.calendarTypes = val
            if (val.indexOf(3) === -1) {
                this.isDisableSubTypeCalendar = true
                this.bookingCalendarObj.bookingType = []
            } else {
                this.bookingCalendarObj.bookingType = [1, 2, 3]
                this.isDisableSubTypeCalendar = false
            }
            await this.fetchCalendarEventInfo()
            this.bookingCalendarObj.loading = false
        },
        async handleSelectCourierHolidays (val) {
            this.bookingCalendarObj.loading = true
            this.bookingCalendarObj.courierHolidays = val
            await this.fetchCalendarEventInfo()
            this.bookingCalendarObj.loading = false
        },
        async handleSelectBookingType (val) {
            this.bookingCalendarObj.loading = true
            this.bookingCalendarObj.bookingType = val
            await this.fetchCalendarEventInfo()
            this.bookingCalendarObj.loading = false
        },
        datesRender (info) {
            let fc = document.getElementsByClassName('fc-day-number')
            let array = []
            for (let fcKey in fc) {
                let ele = parseInt(fc[fcKey].innerText)
                if (fcKey >= ele - 1) {
                    array.push(fc[fcKey])
                    fc[fcKey].style.color = '#2C3E50'
                    if ((fcKey - ele) >= 12) {
                        array.pop()
                        break
                    }
                }
            }
            for (let key in this.bookingCalendarObj.calendarInfo) {
                let ele = this.bookingCalendarObj.calendarInfo[key]
                // array[key - 1].style.color = 'blue'
                if (ele.holiday !== null) {
                    array[key - 1].style.color = '#FF0000'
                }
            }
        }
    }
}
</script>
<style lang="scss">
    .font-sarabun-kan-style{
        font-family: 'Sarabun';
    }
    .font-size-16-kan-style{
        font-size: 16px;
    }
    .font-size-18-kan-style{
        font-size: 18px;
    }
    .font-size-20-kan-style{
        font-size: 20px;
    }
    .booking-calendar-check-list-header-kan-style{
        color: #2C3E50;
        font-weight: 500;
    }
    .booking-calendar-base-drop-down-kan-style{
        background-color: #08A7A3;
        border: 1px solid #08A7A3;
        max-width: 130px;
        min-width: 130px;
    }
    .booking-calendar-base-drop-down-btn-kan-style{
        max-width: 150px;
        min-width: 150px;
    }
    .booking-calendar-type-checkbox-kan-style{
        font-family: 'Sarabun';
        .el-checkbox__input.is-checked .el-checkbox__inner{
            background-color: #08A7A3;
            border-color: #08A7A3;
        }
    }
    .booking-calendar-courier-checkbox-kan-style{
        font-family: 'Sarabun';
        display: block;
        .el-checkbox__input.is-checked .el-checkbox__inner{
            background-color: var(--tooltip-color);
            border-color: var(--tooltip-color);
        }
    }
    .booking-calendar-holiday-checkbox-kan-style{
        font-family: 'Sarabun';
        display: block;
        .el-checkbox__input.is-checked .el-checkbox__inner{
            background-color: #FF0000;
            border-color: #FF0000;
        }
    }
    .book-calendar-kan-style {
        margin: 0;
        max-height: 100%;
        max-width: 100%;
        .fc-more-cell{
            div{
                border: 1px solid #ffffff;
                background-color: #A0A0A0;
                border-radius: 7px;
                .fc-more{
                    color: #ffffff;
                    pointer-events: none;
                }
            }
        }
    }

</style>
